import "./App.css";
import { useState, useEffect } from "react";
import { Amplify } from "aws-amplify";
import outputs from "./amplify_outputs.json";
import { signInWithRedirect, getCurrentUser } from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";

Amplify.configure(outputs);

function App() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [customState, setCustomState] = useState(null);

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signInWithRedirect":
          getUser();
          break;
        case "signInWithRedirect_failure":
          setError("An error has ocurred during the OAuth flow.");
          break;
        case "customOAuthState":
          setCustomState(payload.data);
          break;
      }
    });

    getUser();

    return unsubscribe;
  }, []);

  const getUser = async () => {
    try {
      const currentUser = await getCurrentUser();
      setUser(currentUser);
      return currentUser;
    } catch (error) {
      console.error(error);
      console.log("Not signed in");
    }
  };

  const verifyLoggedIn = async () => {
    const currentUser = await getUser();
    if (!user && !currentUser) {
      await signInWithRedirect({
        provider: {
          custom: "DigitalMEGenesysKTAzureSSO",
        },
      });
    }
  };

  useEffect(() => {
    verifyLoggedIn();
  }, []);

  return <div id="genesys-support-center"></div>;
}

export default App;
